import React from "react";
import "./Job_Address.css";
import Job_Address_card from "../../Common-Component/Job_Address_card/Job_Address_card";

function Job_Address({order}) {
  return (
    <>
      <div className="Job_Address">
        <div className="row">
          <div className="col-md-6">
            <Job_Address_card order={order?.Order?.BillingAddress} />
          </div>

          <div className="col-md-6">
            <Job_Address_card  order={order?.Order?.ShippingAddress}/>
          </div>
        </div>
      </div>
    </>
  );
}

export default Job_Address;
